// @ts-nocheck

import React from 'react';
import dynamic from 'next/dynamic';
import HeadNext from 'next/head';
import NextDefaultError from 'next/error';
import useServerEnv from '@magalu/rave/config/useServerEnv';
import useClientEnv from '@magalu/rave/config/useClientEnv';

import { client, useClient } from '@magalu/rave/graphql';
import { parseHeaders, shouldRender, middlewareClientExecutor, middlewareServerExecutor } from '@magalu/rave/utils';
import { withEventsLayer } from '@magalu/rave/hocs';
import { ErrorBoundary } from '@magalu/rave/errorBoundary';
import { ComponentErrorBoundary } from '@magalu/rave/errorBoundary';

import events from '../../events';

import { Head, ActivityDetection } from '@magalu/rave/components';

// Modules
import { Preconnect } from '@magalu/rave/components';
import GoogleTagManager from '@magalu/ecomm-components/rave/scripts/GoogleTagManager';
import AllIn from '@magalu/ecomm-components/rave/scripts/AllIn';
import Criteo from '@magalu/ecomm-components/rave/scripts/Criteo';
import Bing from '@magalu/ecomm-components/rave/scripts/Bing';
import TikTok from '@magalu/ecomm-components/rave/scripts/TikTok';
import RTBHouse from '@magalu/ecomm-components/rave/scripts/RTBHouse';
import Stewie from '@magalu/ecomm-components/rave/scripts/Stewie';
import SpotifyAdAnalytics from '@magalu/ecomm-components/rave/scripts/SpotifyAdAnalytics';
import Vwo from '@magalu/ecomm-components/rave/scripts/Vwo';
import Header from '@magalu/ecomm-components/rave/Header';
import EventPageViewDispatcher from '@magalu/ecomm-components/rave/EventPageViewDispatcher';
import PageLoading from '@magalu/ecomm-components/components/PageLoading';
import Row from '@magalu/ecomm-components/components/Row';
import Breadcrumb from '@magalu/ecomm-components/components/Breadcrumb';
import Heading from '@magalu/ecomm-components/rave/Heading';
import List from '@magalu/ecomm-components/components/List';
import ListItem from '../../modules/ListItem';
import { TomIconQueroDeCasamento } from '@magalu/tom-icons/react/ts';
import Button from '@magalu/ecomm-components/rave/Button';
import Footer from '@magalu/ecomm-components/components/Footer';
import AlertFeedback from '../../modules/AlertFeedback';
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const Hotjar = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/scripts/Hotjar'), {
  ssr: false
});
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const Loader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/Loader'), {
  ssr: false
});
/**
* for client modules in typescript, need to use dynamic<T> as any
* read: https://github.com/vercel/next.js/issues/4515
*/
const StateLoader = dynamic<any>(() =>
  import('@magalu/ecomm-components/rave/StateLoader'), {
  ssr: false
});

// Middlewares
import getUserInfo from '@magalu/ecomm-components/rave/middlewares/getUserInfo';
import getPlatformEnvs from '../../middlewares/getPlatformEnvs';
import getVersions from '../../middlewares/getVersions';
import checkLogin from '../../middlewares/checkLogin';


const cachePolicies = {};
const localTypeDefs = undefined;
const linkMiddlewares = [];

import { getParsedQuery, useRouter, useCookies, withRouter, getDeviceInfo } from '@magalu/rave/router';

import { withClientMiddlewares } from '@magalu/rave/hocs';

import {
    getGlobalClassName, routeInfo, getComponents, getHeadProps,
    dataSource, getPageVariables, middlewaresArgs,
    manifest, config as raveConfig, componentsList
  } from './settings';

import routes from '../../rave-routes';

const Custom404 = dynamic(() => import('../../containers/notfound').catch(() => null));
const CustomError = dynamic(() =>
  import('../../containers/internalError').catch(() => NextDefaultError)
);


const Container = (props : Record<string, any>  = {}) => {

  const { client: clientConfig } = useClientEnv();
  const route = useRouter();

  // Filter out non-DOM props from incoming props before any usage
  const {
    componentsList,
    appConfig,
    clientConfig: _,
    fetchPriority,
    isServerRequest,
    middlewaresExecuted,
    stopRender,
    ...rest
  } = props;
  
  // Override props with cleaned version
  props = rest;
  
  const pageProps = { ...rest, appConfig: raveConfig, clientConfig, isServerRequest, manifest, route };

  const headProps = getHeadProps(pageProps);

  const componentProps = getComponents(pageProps);
  const className = getGlobalClassName(pageProps);
  const gridStyleHtml = {__html: `#your-account{display: grid;grid-template-areas: 'header' 'content' 'beforesidebar' 'sidebar' 'aftersidebar' 'aftercontent' 'footer';grid-template-columns: 100%;grid-template-rows: auto;}@media(min-width: 744px){#your-account{display: grid;grid-template-areas: 'header header header header' '. content content .' '. beforesidebar sidebar .' '. aftersidebar sidebar .' 'aftercontent aftercontent aftercontent aftercontent' 'footer footer footer footer';grid-template-columns: 1fr minmax(0, calc(1368px - 360px)) 360px 1fr;grid-template-rows: auto;}}`}

    if(!middlewaresExecuted || stopRender) {
      return null;
    }

  return (
    <>
      <HeadNext>
        <style dangerouslySetInnerHTML={gridStyleHtml}/>
      </HeadNext>
  
      <div id="your-account" className={className}>
          <Head {...props} {...headProps} />
        
            <header { ...{"style":{"gridArea":"header"}} }>
                
                
                
                
                <Preconnect { ...props} {...(componentProps['header-preconnect-0']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <GoogleTagManager { ...props} {...(componentProps['header-google-tag-manager-1']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <AllIn { ...props} {...(componentProps['header-all-in-2']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <Criteo { ...props} {...(componentProps['header-criteo-3']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <Bing { ...props} {...(componentProps['header-bing-4']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <TikTok { ...props} {...(componentProps['header-tik-tok-5']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <RTBHouse { ...props} {...(componentProps['header-rtbhouse-6']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <Stewie { ...props} {...(componentProps['header-stewie-7']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <SpotifyAdAnalytics { ...props} {...(componentProps['header-spotify-ad-analytics-8']?.props || {})}/>
                
                
                
                
                
                
                <ActivityDetection {...componentProps['header-hotjar-9'].csr.props}>
                
                
                <Hotjar { ...props} {...(componentProps['header-hotjar-9']?.props || {})}/>
                
                
                </ActivityDetection>
                
                
                
                
                
                
                <Vwo { ...props} {...(componentProps['header-vwo-10']?.props || {})}/>
                
                
                
                
                
                
                <ActivityDetection {...componentProps['header-loader-11'].csr.props}>
                
                
                 
                <Loader { ...props} {...(componentProps['header-loader-11']?.props || {})}>
                
                
                
                
                <PageLoading { ...props} {...(componentProps['header-loader-11-children-page-loading-0']?.props || {})}/>
                
                
                
                
                 
                </Loader>
                
                
                </ActivityDetection>
                
                
                
                <ActivityDetection {...componentProps['header-state-loader-12'].csr.props}>
                
                
                 
                <StateLoader { ...props} {...(componentProps['header-state-loader-12']?.props || {})}>
                
                <ActivityDetection {...componentProps['header-state-loader-12-children-page-loading-0'].csr.props}>
                
                
                <PageLoading { ...props} {...(componentProps['header-state-loader-12-children-page-loading-0']?.props || {})}/>
                
                
                </ActivityDetection>
                
                 
                </StateLoader>
                
                
                </ActivityDetection>
                
                
                
                
                
                
                <Header { ...props} {...(componentProps['header-header-13']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <EventPageViewDispatcher { ...props} {...(componentProps['header-event-page-view-dispatcher-14']?.props || {})}/>
                
                
                
                
                
            </header>
            <section { ...{"style":{"gridArea":"content"}} }>
                
                
                
                
                 
                <Row { ...props} {...(componentProps['content-row-0']?.props || {})}>
                
                
                
                
                 
                <Breadcrumb { ...props} {...(componentProps['content-row-0-children-breadcrumb-0']?.props || {})}>
                
                
                
                
                <Breadcrumb.Item { ...props} {...(componentProps['content-row-0-children-breadcrumb-0-children-breadcrumb.-item-0']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <Breadcrumb.Item { ...props} {...(componentProps['content-row-0-children-breadcrumb-0-children-breadcrumb.-item-1']?.props || {})}/>
                
                
                
                
                 
                </Breadcrumb>
                
                
                
                
                 
                </Row>
                
                
                
                
                
            </section>
            <section { ...{"className":"md:pr-xsm md:pt-md","style":{"gridArea":"beforesidebar"}} }>
                
                
                
                
                 
                <Row { ...props} {...(componentProps['beforesidebar-row-0']?.props || {})}>
                
                
                
                
                 
                <Row { ...props} {...(componentProps['beforesidebar-row-0-children-row-0']?.props || {})}>
                
                
                
                
                 
                <Row { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-0']?.props || {})}>
                
                
                
                
                <Heading { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-0-children-heading-0']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <Heading { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-0-children-heading-1']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <Heading { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-0-children-heading-2']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                 
                <List { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-0-children-list-3']?.props || {})}>
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-0-children-list-3-children-list-item-0']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-0-children-list-3-children-list-item-1']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-0-children-list-3-children-list-item-2']?.props || {})}/>
                
                
                
                
                 
                </List>
                
                
                
                
                 
                </Row>
                
                
                
                
                 
                
                
                
                
                 
                <Row { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-1']?.props || {})}>
                
                
                
                
                <Heading { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-1-children-heading-0']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                 
                <List { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-1-children-list-1']?.props || {})}>
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-0']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-1']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-2']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-3']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-1-children-list-1-children-list-item-4']?.props || {})}/>
                
                
                
                
                 
                </List>
                
                
                
                
                 
                </Row>
                
                
                
                
                 
                
                
                
                
                 
                <Row { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-2']?.props || {})}>
                
                
                
                
                <Heading { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-2-children-heading-0']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                 
                <List { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-2-children-list-1']?.props || {})}>
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-2-children-list-1-children-list-item-0']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <ListItem { ...props} {...(componentProps['beforesidebar-row-0-children-row-0-children-row-2-children-list-1-children-list-item-1']?.props || {})}/>
                
                
                
                
                 
                </List>
                
                
                
                
                 
                </Row>
                
                
                
                
                 
                </Row>
                
                
                
                
                 
                </Row>
                
                
                
                
                
            </section>
            <aside { ...{"className":"pt-xsm md:pt-md","style":{"gridArea":"sidebar"}} }>
                
                
                
                
                 
                <Row { ...props} {...(componentProps['sidebar-row-0']?.props || {})}>
                
                
                
                
                 
                <Row { ...props} {...(componentProps['sidebar-row-0-children-row-0']?.props || {})}>
                
                
                
                
                <TomIconQueroDeCasamento { ...props} {...(componentProps['sidebar-row-0-children-row-0-children-tom-icon-quero-de-casamento-0']?.props || {})}/>
                
                
                
                
                 
                </Row>
                
                
                
                
                 
                
                
                
                
                <Heading { ...props} {...(componentProps['sidebar-row-0-children-heading-1']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <Heading { ...props} {...(componentProps['sidebar-row-0-children-heading-2']?.props || {})}/>
                
                
                
                
                 
                
                
                
                
                <Button { ...props} {...(componentProps['sidebar-row-0-children-button-3']?.props || {})}/>
                
                
                
                
                 
                </Row>
                
                
                
                
                
            </aside>
            <footer { ...{"style":{"gridArea":"footer"}} }>
                
                
                
                
                <Footer { ...props} {...(componentProps['footer-footer-0']?.props || {})}/>
                
                
                
                
                
                
                
                
                
                <AlertFeedback { ...props} {...(componentProps['footer-alert-feedback-1']?.props || {})}/>
                
                
                
                
                
            </footer>
      </div>
    </>
  )
};


let clientProps = {};
clientProps.manifest = manifest;
clientProps.appConfig = raveConfig || {};
clientProps.route = {
  id: routeInfo.id,
  name: routeInfo.name,
  pathPattern: routeInfo.pathPattern,
  pathAliases: routeInfo.pathAliases,
  renderMethod: routeInfo.renderMethod
};
clientProps.isServerRequest = false;
clientProps.componentsList = componentsList;

  const clientSideBeforeFetchMiddlewares = [
    { id: 'getUserInfo', functionMiddleware: getUserInfo },
    { id: 'getPlatformEnvs', functionMiddleware: getPlatformEnvs },
    { id: 'getVersions', functionMiddleware: getVersions },
  ];

  const clientSideAfterFetchMiddlewares = [
    { id: 'checkLogin', functionMiddleware: checkLogin },
  ];

export default withRouter(
  withClientMiddlewares(
    withEventsLayer(
      Container,
      {
        routeInfo: routeInfo,
        events: events(),
        eventsCustomConfig: {},
        dataStoreSetupKey: "",
        clientProps: clientProps,
      }
    ),
    {
      clientProps: clientProps,
      clientSideBeforeFetchMiddlewares: clientSideBeforeFetchMiddlewares,
      clientSideAfterFetchMiddlewares: clientSideAfterFetchMiddlewares,
      middlewaresArgs: middlewaresArgs,
    }
  ),
  { ...routeInfo, manifest },
  false,
  routes
);
